import { useCallback, useMemo } from 'react';
import {
  convertAmericanToDecimal,
  convertAmericanToFractional,
  convertDecimalOddsToFractional,
  convertDecimalToAmerican,
  convertFractionalToAmerican,
  convertFractionalToDecimal,
} from '@cx-web/utils';

import { ONE_DAY } from '~/constants';
import { CookieService } from '~/services/actions/cookie-actions';
import TrackingActions, {
  TRACKING_ACTIONS,
  TRACKING_CATEGORIES,
  TRACKING_EVENTS,
} from '~/services/actions/tracking-actions';
import { type OddsFormat } from '~/types';
import { type OddsUtils } from '~/types/odds-format';

export const useOddsUtils = (): OddsUtils => {
  const cookieService = useMemo(() => new CookieService(), []);
  const trackingActions = useMemo(() => new TrackingActions(), []);

  const changeOddsFormat = useCallback(
    (newOddsFormat: OddsFormat): void => {
      const cookie = cookieService.select('odds_format');

      cookie.set(newOddsFormat, new Date().getTime() + ONE_DAY);

      trackingActions.eventTracking({
        event: TRACKING_EVENTS.CHANGE_ODDS_FORMAT,
        eventCategory: TRACKING_CATEGORIES.ODDS_FORMAT,
        eventAction: TRACKING_ACTIONS[TRACKING_EVENTS.CHANGE_ODDS_FORMAT],
        eventLabel: newOddsFormat,
      });

      // TODO: CI-1135 replace hard refresh with revalidate
      window.location.reload();
    },
    [cookieService, trackingActions],
  );

  return {
    changeOddsFormat,
    convertAmericanToFractional,
    convertAmericanToDecimal,
    convertFractionalToAmerican,
    convertFractionalToDecimal,
    convertDecimalToAmerican,
    convertDecimalOddsToFractional,
  };
};
